module.exports = __webpack_public_path__ + "img/ennetix-users-page-office-zone-tab3.a9b016bd.png";